<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <CheckoutDetailsReport />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import CheckoutDetailsReport from '@/components/Reports/CheckoutDetailsReport'

export default {
  name: 'ReportsCheckoutDetailsView',
  components: {
    Layout,
    CheckoutDetailsReport
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Início',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatórios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Detalhes do Caixa',
        to: { name: 'ReportCheckoutDetails' },
        active: true
      }
    ]
  }
}
</script>
